import React, { useEffect, useRef, useState, version } from "react";
import { useParams } from "react-router-dom";
import {
  getInvoiceDetail,
  postInvoice,
  updateInvoiceInfo,
} from "../../actions/invoices/invoices";
import { update_page_meta } from "../../actions/page/header";
import { connect } from "react-redux";
import PageHeader from "../../components/page/PageHeader";
import PrintableInvoice from "../../components/PrintableInvoice";
import { useReactToPrint } from "react-to-print";
import CustomBootstrapModal from "../../components/customBootstrapModal";

const InvoiceDetail = ({ update_page_meta }) => {
  const { invoiceId } = useParams();
  const isNumeric = /^[0-9]+$/.test(invoiceId);
  const printableInvoiceWrapperRef = useRef(null);
  const [invoice, setInvoice] = useState(null);
  const [invoiceInfoFormModal, setInvoiceInfoFormModal] = useState(false);
  const [form, setForm] = useState({
    eway_bill_no: invoice?.eway_bill_no,
    vehicle_no: invoice?.vehicle_no,
  });
  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleUpdateInfo = async () => {
    let res = await updateInvoiceInfo(invoiceId, form);
    if (res.success) {
      setInvoice({
        ...invoice,
        eway_bill_no: form.eway_bill_no,
        vehicle_no: form.vehicle_no,
      });
    } else {
      window.alert(`Error: ${res.detail}`);
    }
  };

  const handlePrint = useReactToPrint({
    contentRef: printableInvoiceWrapperRef,
    documentTitle: invoice?.invoice_no || "Invoice",
  });
  useEffect(() => {
    if (!isNumeric) return;
    const fetch = async () => {
      let res = await getInvoiceDetail(invoiceId);
      if (!res.success) {
        setInvoice(res);
      }
    };
    fetch();
  }, [invoiceId]);
  console.log(JSON.stringify(invoice, null, 2));
  const title =
    invoice?.invoice_no || `${invoice?.invoice_type?.toUpperCase()} INVOICE`;
  useEffect(() => {
    if (invoice) {
      update_page_meta({
        title: `${title} | ${invoice?.order_reference}`,
        description: `Invoice Details`,
      });
      setForm({
        eway_bill_no: invoice?.eway_bill_no,
        vehicle_no: invoice?.vehicle_no,
      });
    }
  }, [invoice, update_page_meta]);
  const handlePostInvoice = async () => {
    if (
      !invoice ||
      !invoice?.invoice_type ||
      !["draft", "proforma"].includes(invoice.invoice_type.toLowerCase())
    ) {
      return; // Only allow posting if invoice is in DRAFT or PROFORMA
    }

    const res = await postInvoice(invoiceId);
    if (res.success) {
      setInvoice({
        ...invoice,
        invoice_no: res.invoice_no,
        invoice_type: "TAX",
      });
    } else if (res.detail) {
      alert(`Failed to post invoice: ${res.detail}`);
    }
  };
  if (!isNumeric) {
    return null;
  }

  return (
    <>
      <PageHeader title={title} />

      <div className="row layout-top-spacing" id="cancel-row">
        <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing no-print">
          {["draft", "proforma"].includes(
            invoice?.invoice_type.toLowerCase()
          ) && (
            <button
              class="btn btn-primary mb-2 me-2"
              onClick={handlePostInvoice}
            >
              Post Invoice
            </button>
          )}
          {invoice?.invoice_type.toLowerCase() === "tax" && (
            <button class="btn btn-danger mb-2 me-2">Cancel Invoice</button>
          )}
          {invoice?.invoice_type.toLowerCase() === "draft" && (
            <button class="btn btn-danger mb-2 me-2">Delete Invoice</button>
          )}
          {["proforma", "tax"].includes(
            invoice?.invoice_type.toLowerCase()
          ) && (
            <button
              onClick={handlePrint}
              class="btn btn-primary mb-2 me-2"
              disabled={!printableInvoiceWrapperRef.current}
            >
              Print Invoice
            </button>
          )}
          {["draft", "proforma", "tax"].includes(
            invoice?.invoice_type.toLowerCase()
          ) && (
            <button
              onClick={() => setInvoiceInfoFormModal(true)}
              class="btn btn-primary mb-2 me-2"
              disabled={invoiceInfoFormModal}
            >
              Update Info
            </button>
          )}
        </div>
        <div className="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <div className="invoice-print" ref={printableInvoiceWrapperRef}>
              {invoice && (
                <>
                  <PrintableInvoice
                    invoice={invoice}
                    bankDetails={{
                      accountName: "Apogee Mattress Private Limited",
                      bankName: "IDBI BANK, CHANDRASEKHARPUR BBSR",
                      accountNumber: "1160651100001236",
                      ifsc: "IBKL0001160",
                    }}
                  />
                  <div className="print-only">
                    <PrintableInvoice
                      invoice={invoice}
                      bankDetails={{
                        accountName: "Apogee Mattress Private Limited",
                        bankName: "IDBI BANK, CHANDRASEKHARPUR BBSR",
                        accountNumber: "1160651100001236",
                        ifsc: "IBKL0001160",
                      }}
                      duplicate={true}
                      triplicate={false}
                    />
                    <PrintableInvoice
                      invoice={invoice}
                      bankDetails={{
                        accountName: "Apogee Mattress Private Limited",
                        bankName: "IDBI BANK, CHANDRASEKHARPUR BBSR",
                        accountNumber: "1160651100001236",
                        ifsc: "IBKL0001160",
                      }}
                      duplicate={false}
                      triplicate={true}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <CustomBootstrapModal
          show={invoiceInfoFormModal}
          setShow={setInvoiceInfoFormModal}
          title={"Update Info"}
          onClose={() => setInvoiceInfoFormModal(false)}
          onSave={handleUpdateInfo}
          hasFooter={true}
        >
          <form>
            <div class="mb-3">
              <label for="ewaybillinput" class="form-label">
                EWAY Bill Number
              </label>
              <input
                type="text"
                class="form-control"
                id="ewaybillinput"
                name="eway_bill_no"
                onChange={handleFormChange}
                value={form?.eway_bill_no}
              />
            </div>
            <div class="mb-3">
              <label for="vehiclenoinput" class="form-label">
                Motor Vehicle Number
              </label>
              <input
                type="text"
                class="form-control"
                id="vehiclenoinput"
                name="vehicle_no"
                onChange={handleFormChange}
                value={form?.vehicle_no}
              />
            </div>
          </form>
        </CustomBootstrapModal>
      </div>
    </>
  );
};

export default connect(null, { update_page_meta })(InvoiceDetail);
